<template>
    <button
        @click="$emit('toggleMenu')"
        :class="[
            { 'bg-sidebar-active text-sidebar-active-text': groupIsActive },
            { 'underline-hover': !groupIsActive },
            'p-6 pl-11 border-b border-t-4 border-sidebar-border flex items-center justify-between transition-colors duration-button-hover w-full',
        ]"
    >
        <p v-text="$lang.get('Administration')" />

        <PhCaretUp
            :class="[
                menuOpen
                    ? '[transform:rotateX(0deg)]'
                    : '[transform:rotateX(180deg)]',
                'w-6 flex-shrink-0 transition-transform duration-500 ease-in-out',
            ]"
        />
    </button>

    <VerticalSlideTransition :show="menuOpen">
        <Link
            v-for="link in adminLinks"
            @click="$emit('linkClicked', link)"
            :href="$localizedRoute(link.routeName)"
            :class="[
                {
                    'bg-sidebar-active text-sidebar-active-text': link.active,
                },
                linkClasses,
            ]"
        >
            <p v-text="link.title" />
            <PhArrowRight class="w-6" />
        </Link>
    </VerticalSlideTransition>
</template>
<script>
import { Link } from '@inertiajs/vue3'
import { PhCaretUp, PhArrowRight } from '@phosphor-icons/vue'
import VerticalSlideTransition from '@/Components/Transitions/VerticalSlideTransition.vue'

export default {
    components: {
        VerticalSlideTransition,
        PhCaretUp,
        PhArrowRight,
        Link,
    },

    emits: ['linkClicked', 'toggleMenu'],

    props: {
        menuOpen: {
            type: Boolean,
            required: true,
        },
        adminLinks: {
            type: Array,
            required: true,
        },
    },

    beforeCreate() {
        this.padding = 'pl-11 pr-6'
        this.linkClasses =
            'underline-hover transition-colors duration-button-hover w-full justify-between text-left pl-14 p-4 border-b border-sidebar-border text-md flex gap-x-2'
    },

    computed: {
        groupIsActive() {
            return this.adminLinks.some((link) => link.active)
        },
    },
}
</script>
